var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.454 1.273h-.636V0h-1.272v1.273H4.182V0H2.909v1.273h-.636c-.7 0-1.273.572-1.273 1.272v10.182c0 .7.573 1.273 1.273 1.273h10.181c.7 0 1.273-.573 1.273-1.273V2.545c0-.7-.572-1.272-1.273-1.272zm0 11.454H2.274V4.455h10.181v8.272z"
  })));
}
export default SvgCalendar;